import { render, staticRenderFns } from "./dashboard-personnel.vue?vue&type=template&id=d827a462&scoped=true&"
import script from "./dashboard-personnel.vue?vue&type=script&lang=js&"
export * from "./dashboard-personnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d827a462",
  null
  
)

export default component.exports